// Примеры файлов для загрузки заказов (Upload Order → File Example / Seeds CSV Example).
// Колонки описаны в components/ReferenceGuidePopup.jsx; количество и цена — в единице и валюте,
// выбранных в окне загрузки, duties и lab_testing — USD на строку (необязательные).
const EXAMPLES = {
  materials: {
    name: 'MaterialOrder_Example.csv',
    lines: [
      'sku,year,month_num,supplierName,statusID,qty,price_per_pcs,est_del_date,bo_follow_up_date,tracking,duties',
      'SB-001,2026,10,Supplier ABC,S,5000,0.05,2026-10-15,,TRK123456,120.00',
      'SB-002,2026,10,Supplier ABC,BO,3000,0.04,,2026-10-20,,',
    ],
  },
  seeds: {
    name: 'SeedsOrder_Example.csv',
    lines: [
      'seedsid,year,month_num,supplierName,statusID,qty,price,est_del_date,bo_follow_up_date,tracking,duties,lab_testing',
      '101,2026,10,Seeds Supplier Co,S,50.00,12.50,2026-10-15,,TRK123456,120.00,45.00',
      '205,2026,10,Seeds Supplier Co,BO,25.50,8.75,,2026-10-20,,,',
    ],
  },
};

export const exampleCsv = kind => EXAMPLES[kind].lines.join('\n');

export function downloadOrderExample(kind) {
  const url = URL.createObjectURL(new Blob([exampleCsv(kind)], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = EXAMPLES[kind].name;
  a.click();
  URL.revokeObjectURL(url);
}
